import React from 'react';
import Paper from "@mui/material/Paper";
import {greyishBlue50} from "assets/jss/main";

import {TableContainer} from "@mui/material";

function StyledTableContainer(props) {
    return (
        <TableContainer
            component={Paper}
            elevation={0}
            sx={{
                border: `1px solid ${greyishBlue50}`,
                borderRadius: "12px",
                overflow: "hidden",
                ...props.sx
            }}
        >
            {props.children}
        </TableContainer>
    );
}

export default StyledTableContainer;
